import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';
import './ContactHero.css';

const ContactHero = () => {
  return (
    <Box className="contact-hero">
      <div className="contact-hero-overlay" />
      <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <motion.div
          className="contact-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="subtitle1"
            className="contact-hero-subtitle-top"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Get in Touch
          </Typography>
          <Typography
            variant="h1"
            className="contact-hero-title"
            component={motion.h1}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            CONTACT US
          </Typography>
          <Typography
            className="contact-hero-description"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Whether you're a startup or an enterprise, we're here to help turn your ideas into reality. 
            Our team is ready to discuss your project needs, provide expert consultation, or explore potential 
            partnerships. Let's connect and create something exceptional together.
          </Typography>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            {/* <Button 
              variant="contained" 
              color="primary" 
              size="large"
              className="contact-hero-button"
            >
              REQUEST A QUOTE
            </Button> */}
          </motion.div>
        </motion.div>
      </Container>
    </Box>
  );
};

export default ContactHero; 